'use client';

import Script from 'next/script';

import { useEffect, useRef } from 'react';

import { useSiteSettingsContext } from '@/core/providers/site-settings-provider';
import type { SiteSettings } from '@/lib/contentful';
import { cn } from '@/lib/utils';

export type TrustpilotModuleProps = {
    className?: string;
} & Pick<SiteSettings['fields'], 'trustpilotBusinessUnitId' | 'trustpilotTemplateId' | 'trustpilotFallbackUrl'>;

export function TrustpilotModule({
    className,
    trustpilotTemplateId = '53aa8912dec7e10d38f59f36',
    trustpilotBusinessUnitId = '46e975310000640005016b22',
    trustpilotFallbackUrl = 'https://dk.trustpilot.com/review/www.kulturrejser-europa.dk',
}: TrustpilotModuleProps) {
    const containerRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const loadTrustpilotWidget = () => {
            if (window.Trustpilot) {
                const element = containerRef.current;
                if (element) {
                    window.Trustpilot.loadFromElement(element, true);
                }
            }
        };

        loadTrustpilotWidget();
    }, []);

    const { locale } = useSiteSettingsContext();

    return (
        <div className={cn(className)}>
            <Script
                id='_next-trustpilot-widget'
                async
                src={`//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js`}
                onLoad={() => {
                    const element = containerRef.current;
                    if (window.Trustpilot && element) {
                        window.Trustpilot.loadFromElement(element, true);
                    }
                }}
            />
            <div
                ref={containerRef}
                className='min-h-36 text-center'
                data-locale={locale === 'no' ? 'nb-NO' : locale}
                data-template-id={trustpilotTemplateId}
                data-businessunit-id={trustpilotBusinessUnitId}
                data-style-height='144px'
                data-style-width='100%'
                data-stars='4,5'
                data-review-languages='da'>
                <a href={trustpilotFallbackUrl} target='_blank' rel='noopener'>
                    Trustpilot
                </a>
            </div>
        </div>
    );
}
